import React, { createContext, useState, useEffect, useContext } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart должен использоваться внутри CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    // Загружаем корзину из localStorage при инициализации
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        const parsed = JSON.parse(savedCart);
        if (Array.isArray(parsed)) {
          return parsed.filter(item => item && item.product && item.product._id);
        }
        return [];
      } catch (error) {
        console.error('Ошибка загрузки корзины:', error);
        return [];
      }
    }
    return [];
  });

  // Сохранение корзины в localStorage при изменении
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, quantity = 1, unit = 'piece') => {
    setCart((prevCart) => {
      const existingItem = prevCart.find(
        item => item.product._id === product._id && item.unit === unit
      );
      
      if (existingItem) {
        return prevCart.map(item =>
          item.product._id === product._id && item.unit === unit
            ? { ...item, quantity: existingItem.quantity + quantity }
            : item
        );
      } else {
        return [...prevCart, { product, quantity, unit }];
      }
    });

    return { success: true };
  };

  const removeFromCart = (productId, unit) => {
    setCart((prevCart) => prevCart.filter(
      item => !(item.product._id === productId && item.unit === unit)
    ));
  };

  const updateQuantity = (productId, quantity, unit) => {
    if (quantity <= 0) {
      removeFromCart(productId, unit);
      return { success: true };
    }
    
    setCart((prevCart) =>
      prevCart.map(i =>
        i.product._id === productId && i.unit === unit
          ? { ...i, quantity }
          : i
      )
    );
    
    return { success: true };
  };

  const clearCart = () => {
    setCart([]);
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => {
      let price;
      if (item.unit === 'box' && item.product.boxPrice) {
        price = item.product.finalBoxPrice || item.product.boxPrice;
      } else {
        price = item.product.finalPrice || item.product.price;
      }
      return total + (price * item.quantity);
    }, 0);
  };

  const getCartItemsCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0);
  };

  const value = {
    cart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartItemsCount
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

